export const SOCKET_CLIENT = {
  GAME_CREATED: "game-created",
  GAME_BETED: "game-beted",
  RECIEVE_NEW_BET: "recieve-new-bet",
  SEND_MESSAGE: "send-message",
  RECIEVE_MESSAGE: "recieve-message",
  SEND_CHAT_NOTIFICATION: "send-chat-notification",
  RECIEVE_CHAT_NOTIFICATION: "recieve-chat-notification",
};
